// const gsap = () => {
document.addEventListener("DOMContentLoaded", () => {
    console.info('✅ GSAP loaded');
    gsap.registerPlugin(ScrollTrigger)
    if (document.body.classList.contains('home')) {


    //Home Hero
    gsap.timeline({
        scrollTrigger: {
            id: '.main-hero-intro h1',
            trigger: 'section.main-hero',
            start: 'center center',
            end: 'bottom center',
            scrub: 1,
            // markers: true,
        }
    })
    .to('.main-hero-intro h1', {
        y:'-15%',
    }),
    
    gsap.timeline({
        scrollTrigger: {
            id: '.main-hero .page-down',
            trigger: 'section.main-hero',
            start: 'center center',
            end: 'bottom top',
            scrub: 1,
            // markers: true,
        }
    })
    .to('.main-hero .page-down', {
        y:'-100%',
    }),

    gsap.timeline({
        scrollTrigger: {
            trigger: 'section.main-hero',
            start: 'bottom 90%',
            end: 'bottom 10%',
            scrub: true,
            // markers: true,
            ease: 'linear'
        }
    })
    .to('.hero-slider .glide__bullets .glide__bullet', {
        opacity: 0,
        stagger: .2
    }),

    gsap.timeline({
        scrollTrigger: {
            trigger: 'section.main-hero',
            start: 'bottom bottom',
            end: 'bottom top',
            scrub: true,
            // markers: true,
            ease: 'linear'
        }
    })
    .fromTo('.hero-slider .glide__slide img', {
        y: '-10%',
    },{
        y: '10%'
    });




    //Home section offer
    const offerImages = gsap.utils.toArray('.offer-intro-img__wrapper > img');
    const offeritem = gsap.utils.toArray(".offer-intro__list > .offer-intro-item")
    offeritem.forEach((offer, i) => {
        let offerAnim = gsap.timeline({
            scrollTrigger: {
                id: i,
                trigger: offer,
                start: 'top 25%', 
                end: 'bottom 35%',
                // scrub: true,
                // markers: true,
                toggleActions: "play none none reset",
            }
        });
        offerAnim.fromTo(offerImages[i+1], {
            opacity: 0,
            
            // x: '0%',
            // zIndex:0                
        },
        {
            opacity: 1,
            // x: '25%',
            // zIndex:i, 
        })
    }),

    // gsap.timeline({
    //     scrollTrigger: {
    //         trigger: '.offer-intro__list',
    //         start: 'top bottom',
    //         end: 'bottom bottom',
    //         scrub: true,
    //         // markers: true,

    //     }
    // })
    // .to('.offer-intro-img__wrapper', {
    //     x: -20,
    // }),

    // gsap.timeline({
    //     scrollTrigger: {
    //         trigger: '.whyus__content .desc',
    //         start: 'center bottom',
    //         end: 'top center',
    //         scrub: true,
    //         // markers: true,
    //     }
    // })
    // .from('.offer-intro__content > h2', {
    //     x: -20,
    // }),
    
    gsap.timeline({
        scrollTrigger: {
            trigger: '.offer-intro__list',
            start: 'top bottom',
            end: 'bottom 40%',
            scrub: true,
            // markers: true,
            // ease: 'linear'
        }
    })
    .from('.offer-intro__list > li', {
        x: '10%',
        stagger: .2
    }),


    //Home section about
    gsap.timeline({
        scrollTrigger: {
            trigger: 'section.about',
            start: 'top 90%',
            end: 'bottom 10%',
            scrub: 1,
            // markers: true,
            ease: 'linear'
        }
    })
    .to('section.about', {
        backgroundPositionY: "300px",
    }),

    // gsap.timeline({
    //     scrollTrigger: {
    //         trigger: '.whyus__content .desc',
    //         start: 'center bottom',
    //         end: 'top center',
    //         scrub: true,
    //         // markers: true,
    //     }
    // })
    // .to('.whyus__content .desc > h2', {
    //     x: -20,
    // }),
    
    gsap.timeline({
        scrollTrigger: {
            trigger: 'section.about .whyus__img',
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
            // markers: true,
        }
    })
    .from('section.about .whyus__img img', {
        y: "-15%",
    }),


    //Home section blog
    // gsap.timeline({
    //     scrollTrigger: {
    //         trigger: '.blog-prev .desc',
    //         start: 'center bottom',
    //         end: 'top center',
    //         scrub: true,
    //         markers: true,
    //     }
    // })
    // .to('.blog-prev .desc > h2', {
    //     x: -20,
    // }),

    // gsap.timeline({
    //     scrollTrigger: {
    //         trigger: '.posts-grid',
    //         start: 'top bottom',
    //         end: 'bottom top',
    //         scrub: true,
    //         // markers: true,
    //     }
    // })
    // .from('.post-block > img', {
    //     y: '-15%',
    // }),
    

    //Home section work
    gsap.timeline({
        scrollTrigger: {
            trigger: '.careers',
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            // markers: true,
        }
    })
    .from('.careers__content > img', {
        y: '-15%',
    }),


    //Home section references
    gsap.timeline({
        scrollTrigger: {
            trigger: 'section.references',
            start: 'top 90%',
            end: 'bottom 10%',
            scrub: 1,
            // markers: true,
            ease: 'linear'
        }
    })
    .to('section.references', {
        backgroundPositionY: "300px",
    })
    }

    //Footer
    gsap.timeline({
        scrollTrigger: {
            trigger: '.footer__nav.container',
            start: 'center bottom',
            end: 'center 75%',
            scrub: true,
            // markers: true,
            
        }
    })
    .from('.footer #main-menu li', {
        opacity: 0,
        y: 20,
        stagger: .2
    }),

    gsap.timeline({
        scrollTrigger: {
            trigger: '.footer__nav.container',
            start: 'center bottom',
            end: 'center 75%',
            scrub: true,
            // markers: true,            
        }
    })
    .from('.footer #site-menu li', {
        opacity: 0,
        y: 20,
        stagger: .2
    }),

    gsap.timeline({
        scrollTrigger: {
            trigger: '.footer__nav.container',
            start: 'center bottom',
            end: 'center 50%',
            scrub: 1.5,
            // markers: true,            
        }
    })
    .from('.footer__up', {
        // opacity: 0,
        y: 250,
    }),

    gsap.timeline({
        scrollTrigger: {
            trigger: '.footer__nav.container',
            start: 'bottom bottom',
            end: 'center 50%',
            scrub: true,
            // markers: true,            
        }
    })
    .from('#footer-menu', {
        opacity: 0,
        y: 600,
    })
});
// };